export const LANDINGPAGE_ITEM_DESCRIPTION =
  "Odio aenean sed adipiscing diam donec adipiscing";

export default LANDINGPAGE_ITEM_DESCRIPTION;
